import React, { useRef } from "react";

const DEFAULT_TOOLTIP =
  "text-shadow flex text-pretty !z-50 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition bg-greenGlass backdrop-blur-sm text-secondary p-1 rounded absolute whitespace-nowrap shadow shadow-black";

export const tooltipStyles = {
  container: "group relative inline-block",
  tooltip: DEFAULT_TOOLTIP,
  top: DEFAULT_TOOLTIP + " bottom-full mb-2 left-1/2 transform translate-x-1/2",
  topLeft: DEFAULT_TOOLTIP + " bottom-full mb-2 left-0",
  left: DEFAULT_TOOLTIP + " right-full mr-2 top-1/2 transform -translate-y-1/2",
  bottomLeft: DEFAULT_TOOLTIP + " top-full mt-2 left-0",
  bottom: DEFAULT_TOOLTIP + " top-full mt-2 left-1/2 transform translate-x-1/2",
  bottomRight: DEFAULT_TOOLTIP + " bottom-full mb-2 right-0",
  right: DEFAULT_TOOLTIP + " left-full ml-2 top-1/2 transform -translate-y-1/2",
  topRight: DEFAULT_TOOLTIP + " bottom-full mb-2 right-0",
};

const Tooltip = ({
  text = "",
  position = "topLeft",
  classNames = tooltipStyles,
  children,
}) => {
  const tooltipRef = useRef(null);
  const container = useRef(null);

  const handleMouseEnter = (clientX) => {
    if (!tooltipRef.current || !container.current) return;
    const { left } = container.current.getBoundingClientRect();
    const { width } = tooltipRef.current.getBoundingClientRect();
    tooltipRef.current.style.left = `${clientX.clientX - left - width}px`;
  };

  return (
    <div
      ref={container}
      onMouseEnter={handleMouseEnter}
      className="group relative inline-block"
    >
      {children}
      {text && (
        <span
          ref={tooltipRef}
          className={
            classNames[position || "tooltip"] ||
            tooltipStyles[position || "tooltip"]
          }
          style={{
            maxWidth: 'calc("100vw - 2rem")',
          }}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default Tooltip;
